import React, { useState } from "react";
import "./DeliveryManifest.css";
import { Subject } from "rxjs";
import { FormPane } from "../../../components/FormZero/PageComponents/FormPane/FormPane";
import * as XLSX from "xlsx";
import axios from "axios";
import { OrdersDialog } from "../OrdersDialog";
import {
  get_number_of_trays_per_cart,
  isFlaggedNumberOfCarts,
} from "../../CommonInfo";
import {
  DataGrid,
  GridColDef,
  GridValueFormatterParams,
} from "@mui/x-data-grid";
import {
  Dialog,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import {
  setPageTitle,
} from "../../../slices/applicationSlice";
import { IApplication } from "../../../interfaces/IApplication";
import { useAppDispatch } from "../../../hooks";
import { useEffect } from "react";
import { Button } from "@mui/material";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { styled } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import EmailIcon from "@mui/icons-material/Email";
import SmartphoneIcon from "@mui/icons-material/Smartphone";
import Link from "@mui/material/Link";
import {
  GenerateSample,
  RowNumber,
} from "sample_random_data_generator";
import ActionButton from "../../../components/ActionButton";
import ActionMenu from "../../../components/ActionMenu";
import { ISearchChips } from "../../../interfaces/Core/ISearchChips";
import SearchChips from "../../../components/SearchChips";
import { CustomDataGrid } from "../../../components/StripedDataGrid";
import AddExportModalControl from "./AddExportModalControl";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

function BootstrapDialogTitle(props: DialogTitleProps) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

type Anchor = "top" | "left" | "bottom" | "right";

const ProgressBar = React.memo(function ProgressBar(props: any) {
  const { value, text } = props;
  // const valueInPercent = value * 100;
  // {`${value.toLocaleString()} %`}
  return (
    <div
      style={{
        // border: `1px solid ${theme.palette.divider}`,
        border: `1px solid rgba(158,158,158,0.75)`,
        position: "relative",
        overflow: "hidden",
        width: "100%",
        height: 26,
        borderRadius: 10,
      }}
    >
      <div
        style={{
          position: "absolute",
          lineHeight: "24px",
          width: "100%",
          display: "flex",
          justifyContent: "center",
        }}
      >
        {text}
      </div>
      <div
        style={{
          height: "100%",
          backgroundColor: "#89B219",
          maxWidth: `${value}%`,
        }}
      />
    </div>
  );
});

export function DeliveryManifest() {

  function ExportClicked(_event: React.MouseEvent<HTMLElement>): void {
    setShowDialog(true);
  }

  const [open, setOpen] = useState(false);

  function handleClose() {
    setOpen(!open);
  }

  const buttons = [
    <ActionButton action={ExportClicked} buttonLabel="EXPORT" />,

  ];


  const dispatch = useAppDispatch();

  useEffect(() => {
    let appState: IApplication = {
      pageTitle: "Delivery Manifest",
      backgroundPath: "/assets/images/patchingbg.jpg",
    };
    dispatch(setPageTitle(appState));
  }, []);

  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });


  const [helpOpen, setHelpOpen] = React.useState(false);
  const [nextOpen, setNextOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClickHelpOpen = () => {
    setHelpOpen(true);
  };

  const handleHelpClose = () => {
    setHelpOpen(false);
  };

  const [rows, setRows] = React.useState<any>([]);
  const columns: GridColDef[] = [
    { field: "loadNumber", headerName: "Load Number", width: 200 },
    {
      field: "truck",
      headerName: "Truck", //Trucking Shipment Type [FEDEX, etc.]
      width: 200,
      valueGetter: (cellValues: {
        row: { truck: { TruckNumber: any } | null | undefined };
      }) =>
        cellValues.row.truck !== undefined && cellValues.row.truck !== null
          ? cellValues.row.truck.TruckNumber
          : "",
    },
    {
      field: "trailer",
      headerName: "Trailer",
      width: 200,
      valueGetter: (cellValues: {
        row: { trailer: { TrailerNumber: any } | null | undefined };
      }) =>
        cellValues.row.trailer !== undefined && cellValues.row.trailer !== null
          ? cellValues.row.trailer.TrailerNumber
          : "",
    },
    {
      field: 'driver',
      headerName: 'Driver',
      width: 200,
      valueGetter: (cellValues) => cellValues.row.driver.name
    },
    {
      field: "numberOfCarts",
      headerName: "# of Carts",
      width: 200,
      renderCell: (cellValues: {
        row: { deliveryHeaders: any[] | null | undefined };
      }) => {
        let totalFilled = 0;
        let isOneFlagged = false;
        if (
          cellValues.row.deliveryHeaders !== undefined &&
          cellValues.row.deliveryHeaders !== null &&
          Array.isArray(cellValues.row.deliveryHeaders) &&
          cellValues.row.deliveryHeaders.length > 0
        ) {
          cellValues.row.deliveryHeaders.forEach((delivery: { deliveryItems: any[] }) => {
            totalFilled += delivery.deliveryItems.reduce(
              (t: number, item: { orderdQuantity: any }) => {
                if (isFlaggedNumberOfCarts(item)) {
                  isOneFlagged = true;
                }
                return t + get_number_of_trays_per_cart(item, item.orderdQuantity);
              },
              0
            );
          });
        }
        let cartCount = Math.ceil(totalFilled);
        return (
          <>
            <span style={{ color: isOneFlagged ? "#9C27B0" : "black" }}>
              {cartCount}
            </span>
          </>
        );
      },
    },


    {
      field: "truck_capacity",
      headerName: "Capacity",
      width: 200,
      valueGetter: (cellValues: {
        row: {
          truck: { capacity: any } | null | undefined;
          trailer: { capacity: any } | null | undefined;
        };
      }) => {
        return (
          (cellValues.row.truck !== undefined && cellValues.row.truck !== null
            ? cellValues.row.truck.capacity
            : 0) +
          (cellValues.row.trailer !== undefined &&
            cellValues.row.trailer !== null
            ? cellValues.row.trailer.capacity
            : 0)
        );
      },
    },

    {
      field: "percentage",
      headerName: "Capacity Utilization",
      width: 200,
      renderCell: (cellValues: {
        row: {
          deliveryHeaders: any[] | null | undefined;
          truck: { capacity: any } | null | undefined;
          trailer: { capacity: any } | null | undefined;
        };
      }) => {
        let totalFilled = 0;
        if (
          cellValues.row.deliveryHeaders !== undefined &&
          cellValues.row.deliveryHeaders !== null &&
          Array.isArray(cellValues.row.deliveryHeaders) &&
          cellValues.row.deliveryHeaders.length > 0
        ) {
          cellValues.row.deliveryHeaders.forEach((delivery: { deliveryItems: any[] }) => {
            totalFilled += delivery.deliveryItems.reduce(
              (t: number, item: { orderdQuantity: any }) => {
                return t + get_number_of_trays_per_cart(item, item.orderdQuantity);
              },
              0
            );
          });
        }
        let loadFilled = Math.ceil(totalFilled);

        // let used = (cellValues.row.deliveries !== undefined && cellValues.row.deliveries !== null && Array.isArray(cellValues.row.deliveries) && cellValues.row.deliveries.length > 0) ?
        //     cellValues.row.deliveries
        //         .map(d=> d.number_of_carts)
        //         .reduce((t, v) => (t + v))
        //     : 0;
        let capacity =
          (cellValues.row.truck !== undefined && cellValues.row.truck !== null
            ? cellValues.row.truck.capacity
            : 0) +
          (cellValues.row.trailer !== undefined &&
            cellValues.row.trailer !== null
            ? cellValues.row.trailer.capacity
            : 0);
        let value = capacity === 0 ? 0 : (loadFilled / capacity) * 100;

        return (
          <ProgressBar value={value} text={`${loadFilled} / ${capacity}`} />
        );
      },
    },
    {
      field: "calculated_ship_cost",
      headerName: "Shipping Revenue",
      width: 200,
      // renderCell: (cellValues: {
      //   row: {
      //     trayFreightCost: number,
      //     orderedQuantity: number,
      //     deliveryHeaders: any[] | null | undefined;
      //     truck: { capacity: any } | null | undefined;
      //     trailer: { capacity: any } | null | undefined;
      //   };
      // }) => {
      //   if (cellValues.row.deliveryHeaders == null || cellValues.row.deliveryHeaders == undefined) {
      //     return 0;
      //   }
      //   let total = cellValues.row.deliveryHeaders.reduce((total: string, row: { deliveryItems: any[]; trayFreightCost: string; orderedQuantity: any; }) => {
      //     let tray_count = row.deliveryItems.reduce((t: any, s: { OrderdQty: any; }) => t + s.OrderdQty, 0);
      //     console.log(` tfc:${row.trayFreightCost} q:${row.orderedQuantity} t:${tray_count}`);
      //     let n = (parseFloat(row.trayFreightCost) * tray_count);
      //     let val = parseFloat(total) + n;
      //     console.log(val);
      //     console.log(n);
      //     return val;
      //   }, 0)

      //   alert(total);

      //   return new Intl.NumberFormat('en-US', {
      //     style: 'currency',
      //     currency: 'USD'
      //   }).format(cellValues.row.trayFreightCost * cellValues.row.orderedQuantity) // 
      // }
    },
    {
      field: "deliveryHeaders",
      headerName: "Deliveries",
      width: 200,
      renderCell: (cellValues: any) => {
        return <OrdersDialog cellValues={cellValues} />;
      },
    },
  ];

  const formStructure = [
    {
      key: "week_year",
      type: "week-filter",
      size: { default: 4 },
      label: "Patching Week",
      required: true,
    },
    {
      key: "week_year_view",
      type: "header",
      size: { default: 4 },
      valueKey: "week_year",
    },
  ];
  const filterFormSubject = new Subject();
  const [formFilter, setFormFilter] = React.useState<any>({});
  filterFormSubject.subscribe((n) => setFormFilter(n));

  const loadLoads = async function () {
    let outputRows: any[] = [];
    const response = await axios.get(`${process.env.REACT_APP_ENDPOINT}/api/Loads/LoadsWithRelationships`);
    console.log("RESPONSE", response);
    if (response.status === 200) {
      // TODO: refresh the table on the main page? or location.reload
      console.log(response);
      outputRows = [...outputRows, ...response.data];
    }
    setRows(outputRows);
  };

  React.useEffect(() => {
    loadLoads().then();
  }, []);

  // const formSubject = new Subject();
  // const formStructure = [
  //     {
  //         size: {default: 4},
  //         type: "multi-select",
  //         label: "Ship Week",
  //         options: shipWeeks
  //     },
  // ];

  // const panel = (<PanelView rows={rows} />);

  const darkTheme = createTheme({
    palette: {
      mode: "dark",
      primary: {
        main: "#89B219",
      },
    },
  });

  const [searchInformation, setSearchInformation] = React.useState<ISearchChips>();

  const handleSearchChips = (searchInformation: ISearchChips) => {
    setSearchInformation(searchInformation);
  }

  const [showDialog, setShowDialog] = useState(false);

  return (
    <>
      <div>
        <ActionMenu buttons={buttons} />
      </div>
      <AddExportModalControl rows={rows} setShowDialog={setShowDialog} showDialog={showDialog}></AddExportModalControl>
      <Grid container spacing={0} bgcolor="#FFF">
        <div
          className="DeliveryManifest"
          style={{ width: "100%", maxWidth: "100%", height: "100%" }}
        >
          {/*style={{backgroundColor: '#3D3C3C'}}*/}
          {/*style={{marginLeft: '1rem', marginRight: '1rem'}}*/}
          <Grid item xs={12}>
            <ThemeProvider theme={darkTheme}>
              <SearchChips handleSearch={handleSearchChips}></SearchChips>
            </ThemeProvider>
          </Grid>
          {/*<FormPane formStructure={formStructure} formSubject={formSubject}/>*/}
          {/*<pre style={{'height': 'calc(100vh - 209px)', overflow: "scroll"}} >{JSON.stringify(rows, undefined, 4)}</pre>*/}
          <div style={{ height: "calc(100vh - 202px)", width: "100%" }}>
            <CustomDataGrid
              className={"DataGrid"}
              style={{ maxWidth: "100%" }}
              rows={rows}
              columns={columns}
              rowsPerPageOptions={[5, 10]}
              checkboxSelection={false}
              disableSelectionOnClick
            />
          </div>
          {/* <ActionPanel Body={panel} /> */}
        </div>
      </Grid>

      <ThemeProvider theme={darkTheme}>
        <div>
          <BootstrapDialog
            onClose={handleHelpClose}
            aria-labelledby="customized-dialog-title"
            open={helpOpen}
          >
            <BootstrapDialogTitle
              id="customized-dialog-title"
              onClose={handleHelpClose}
            >
              Need Support?
            </BootstrapDialogTitle>
            <DialogContent dividers>
              <Typography sx={{ mb: 3 }} variant="body2" gutterBottom>
                If you are having issues or have questions, please contact us
                below.
              </Typography>
              <Button
                size="large"
                fullWidth
                variant="contained"
                startIcon={<SmartphoneIcon />}
                sx={{ mb: 1, bgcolor: "#89B219" }}
              >
                <Link href="tel:8003141797" underline="none" color="#FFF">
                  <Typography variant="h6" fontWeight={700}>
                    800-314-1797
                  </Typography>
                </Link>
              </Button>
              <Button
                size="large"
                fullWidth
                variant="contained"
                startIcon={<EmailIcon />}
                sx={{ mb: 1, bgcolor: "#89B219" }}
              >
                <Link href="mailto:bobsmarket@idatp.com" underline="none">
                  <Typography variant="h6" fontWeight={700} color="#FFF">
                    support@idatp.com
                  </Typography>
                </Link>
              </Button>
            </DialogContent>
          </BootstrapDialog>
        </div>
      </ThemeProvider>
    </>
  );
}
